export default __webpack_public_path__ + "static/qr-code-f0aed23e3118730d04c30e3331c140ce.png";